var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RoomPreview',{staticClass:"roomPreview miniature",attrs:{"size":_vm.roomSize,"showLabels":false,"fillAll":""}}),_vm._v(" "+_vm._s(_vm.dimensionsSummary)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }